// Rebuy Promo Drawer (Cart Only)
(function () {
  // Complete mapping for all promo types
  const promoToCollection = {
    '2+ for 50% off': 'honest-tees',
    '2+ for 25% off': 'fearless-fleece',
    'Buy 2, Get 1 Free': 'all-socks',
    '3+ for 20% off': 'mix-match-for-20-off',
    '2+ tanks for 50% off': 'womens-tanks'
  };

  // Full messages for promo drawer headings
  const promoTitles = {
    '2+ for 50% off'           : 'Honest Tees BOGO 50% Off',
    '2+ for 25% off'           : 'Buy 2 Fleece, Get 25% Off',
    'Buy 2, Get 1 Free'        : 'Buy 2 Socks, Get 1 Free',
    '3+ for 20% off'           : 'Buy 3, Get 20% Off',
    '2+ tanks for 50% off'     : 'Tank BOGO 50% Off'
  };

  function closePromoDrawer() {
    const drawer = document.getElementById('promo-drawer');
    if (drawer) {
      drawer.classList.remove('promo-drawer--open');
    }
  }

  const cardsCache = {};

  function fetchCollectionCards(collectionHandle) {
    if (!cardsCache[collectionHandle]) {
      cardsCache[collectionHandle] = fetch(`/collections/${collectionHandle}?section_id=promo-drawer-cards`)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then(html => {
          const tpl = document.createElement('template');
          tpl.innerHTML = html;
          const section = tpl.content.querySelector('.shopify-section');
          return (section ? section.innerHTML : html).trim();
        })
        .catch(error => {
          delete cardsCache[collectionHandle];
          throw error;
        });
    }
    return cardsCache[collectionHandle];
  }

  // Initialize Swiper for color swatch carousels inside the promo drawer
function initPromoDrawerSwatches() {
  if (typeof Swiper === 'undefined') return;

  const promoDrawer = document.getElementById('promo-drawer');
  if (!promoDrawer) return;

  const swatchWraps = promoDrawer.querySelectorAll('.swatch-swiper.js-color-swatches.swiper');
  if (!swatchWraps.length) return;

  swatchWraps.forEach(function (container) {
    if (container.swiper) {
      container.swiper.destroy(true, true);
    }

    new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 4,
      freeMode: true,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      touchEventsTarget: 'container',
      threshold: 3,
      resistance: true,
      resistanceRatio: 0.85,
      passiveListeners: false,
      nested: false,
      observer: false,
      observeParents: false,
      a11y: false,
    });
  });
}

  async function createPromoDrawer(promoTag, collectionHandle) {
    // Remove existing drawer if it exists
    const existingDrawer = document.getElementById('promo-drawer');
    if (existingDrawer) {
      existingDrawer.remove();
    }

    const drawer = document.createElement('div');
    drawer.id = 'promo-drawer';
    drawer.className = 'promo-drawer';
    drawer.innerHTML = `
      <div class="promo-drawer__overlay"></div>
      <div class="promo-drawer__content gts">
        <div class="promo-drawer__header">
          <h6>${promoTitles[promoTag] || promoTag || 'Promo Details'}</h6>
          <button class="promo-drawer__close" aria-label="Close drawer">
            ×
          </button>
        </div>
        <div class="promo-drawer__gender-filter">
          <ul class="pdp-gender-toggle">
            <li>
              <a class="ctm-gender-filter-btn pdp-gender-toggle__btn ctm-subbody pdp-gender-toggle__btn--active" data-gender="Women">Women's</a>
            </li>
            <li>
              <a class="ctm-gender-filter-btn pdp-gender-toggle__btn ctm-subbody" data-gender="Men">Men's</a>
            </li>
          </ul>
        </div>
        <div class="promo-drawer__body">
          <div class="promo-drawer__products">
            <div class="loading-spinner">Loading products...</div>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(drawer);

    // Fetch and render products
    if (collectionHandle) {
      try {
        const cardsHtml = await fetchCollectionCards(collectionHandle);
        const productsContainer = drawer.querySelector('.promo-drawer__products');

        if (!drawer.isConnected) return;

        if (cardsHtml) {
          productsContainer.className = 'promo-drawer__products-grid';
          productsContainer.innerHTML = cardsHtml;

          // Initialize gender filter functionality
          initializeGenderFilter();

          // 1. Clone swatch inputs to remove stale listeners (must run first)
          initializeSwatchesForPromoDrawer();

          // 2. Attach size logic after swatch clone — use delegated listener on the drawer
          //    so it survives any future DOM replacement inside wrapper
          if (typeof populateQuickAddBar === 'function') {
            // Initial populate for each card
            drawer.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
              populateQuickAddBar(wrapper);
            });

            // Delegated change listener on drawer — survives cloned nodes
            drawer.addEventListener('change', e => {
              const input = e.target.closest('.js-color-swatches input[type="radio"]');
              if (!input?.checked) return;
              const wrapper = input.closest('.js-color-swatches-wrapper');
              if (wrapper) populateQuickAddBar(wrapper);
            });
          }

          requestAnimationFrame(initPromoDrawerSwatches);

        } else {
          productsContainer.innerHTML = '<p>No products found.</p>';
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        drawer.querySelector('.promo-drawer__products').innerHTML = '<p>Error loading products.</p>';
      }
    } else {
      drawer.querySelector('.promo-drawer__products').innerHTML = '<p>No collection mapping found for this promotion.</p>';
    }

    // Add close functionality
    drawer.querySelector('.promo-drawer__overlay').addEventListener('click', (e) => {
      if (e.target === drawer.querySelector('.promo-drawer__overlay')) {
        e.stopPropagation();
        closePromoDrawer();
      }
    });

    drawer.querySelector('.promo-drawer__content').addEventListener('click', (e) => {
      if (e.target.closest('.sfl-heart')) return;
      e.stopPropagation();
    });

    drawer.querySelector('.promo-drawer__close').addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      closePromoDrawer();
    });
  }

  function openPromoDrawer(promoTag, collectionHandle) {
    createPromoDrawer(promoTag, collectionHandle);
    const drawer = document.getElementById('promo-drawer');
    if (drawer) {
      drawer.classList.add('promo-drawer--open');
    }
  }

  // Function to initialize gender filter functionality
  function initializeGenderFilter() {
    const promoDrawer = document.getElementById('promo-drawer');
    if (!promoDrawer) return;

    const filterButtons = promoDrawer.querySelectorAll('.ctm-gender-filter-btn');
    if (!filterButtons.length) return;

    let currentFilter = 'Women';

    function applyFilter(selectedGender) {
      const productsContainer = promoDrawer.querySelector('.promo-drawer__products-grid');
      if (!productsContainer) return;

      const productCards = promoDrawer.querySelectorAll('.collection-product-card');

      let visibleProductsCount = 0;

      productCards.forEach(card => {
        const productTags = card.getAttribute('data-product-tags') || '';
        const tagsArray = productTags.split(',').map(tag => tag.trim().toLowerCase());

        const hasGenderTag = tagsArray.includes(selectedGender.toLowerCase()) ||
                             tagsArray.includes(selectedGender.toLowerCase() + 's');

        card.classList.toggle('hidden', !hasGenderTag);
        if (hasGenderTag) visibleProductsCount++;
      });

      let noProductsMsg = promoDrawer.querySelector('.promo-drawer__no-products');
      if (!noProductsMsg) {
        noProductsMsg = document.createElement('div');
        noProductsMsg.className = 'promo-drawer__no-products';
        productsContainer.appendChild(noProductsMsg);
      }

      if (visibleProductsCount === 0) {
        noProductsMsg.textContent = `No ${selectedGender} products available`;
        noProductsMsg.classList.add('visible');
      } else {
        noProductsMsg.classList.remove('visible');
      }
    }

    filterButtons.forEach(button => {
      button.addEventListener('click', function () {
        currentFilter = this.getAttribute('data-gender');

        promoDrawer
          .querySelectorAll('.ctm-gender-filter-btn')
          .forEach(btn => btn.classList.remove('pdp-gender-toggle__btn--active'));

        this.classList.add('pdp-gender-toggle__btn--active');
        applyFilter(currentFilter);
      });
    });

  applyFilter(currentFilter);
  }

  // Delegated click handler — set up once, works for any .promo-tag-container
  // Rebuy renders at any time, no re-init needed.
  document.addEventListener('click', function (e) {
    if (window.innerWidth <= 1024) return;

    // Promo tag click → open drawer
    const container = e.target.closest('.rebuy-cart .promo-tag-container');
    if (container && (e.target.closest('.promo-text') || e.target.closest('.promo-info-icon'))) {
      e.preventDefault();
      e.stopPropagation();
      const promoTag = container.getAttribute('data-promo-type');
      openPromoDrawer(promoTag, promoToCollection[promoTag]);
      return;
    }

    // Rebuy close / continue-shopping → close promo drawer
    if (e.target.closest('#rebuy-cart-close') || e.target.closest('.rebuy-cart__continue-shopping-button')) {
      setTimeout(() => closePromoDrawer(), 100);
    }
  });

  function initRebuyPromo() {
    // kept for cursor styling only — click handling is delegated above
    if (window.innerWidth <= 1024) return;
    document.querySelectorAll('.rebuy-cart .promo-tag-container:not([data-cursor-set])').forEach(container => {
      const promoText = container.querySelector('.promo-text');
      const promoIcon = container.querySelector('.promo-info-icon');
      if (promoText) promoText.style.cursor = 'pointer';
      if (promoIcon) promoIcon.style.cursor = 'pointer';
      container.setAttribute('data-cursor-set', 'true');
    });
  }

  // Debounced wrapper — collapses burst of events into one /cart.js call
  let _hidePromoTimer = null;
  function scheduleHideActivatedPromoTags(cartData) {
    clearTimeout(_hidePromoTimer);
    _hidePromoTimer = setTimeout(() => hideActivatedPromoTags(cartData), 300);
  }

  // Replace broad MutationObserver (fired 90+ times on Rebuy init) with
  // targeted cart/Rebuy events so /cart.js is fetched only on real cart changes.
  // rebuy:cart.updated fires once per product rendered — pass e.detail.cart to skip the /cart.js fetch
  document.addEventListener('rebuy:cart.updated',   (e) => { initRebuyPromo(); scheduleHideActivatedPromoTags(e.detail?.cart); });
  document.addEventListener('rebuy:smartcart.ready',() => { initRebuyPromo(); scheduleHideActivatedPromoTags(); });
  document.addEventListener('rebuy:products.loaded', () => { initRebuyPromo(); });
  document.addEventListener('cart:refresh',          () => { scheduleHideActivatedPromoTags(); });
  // gwp:cart-updated carries the full cart object — pass it in to skip the extra fetch
  document.addEventListener('gwp:cart-updated',     (e) => { scheduleHideActivatedPromoTags(e.detail?.cart); });

  // initial run
  initRebuyPromo();
  hideActivatedPromoTags();

  // Close promo drawer when resizing to mobile
  let _promoResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(_promoResizeTimer);
    _promoResizeTimer = setTimeout(function () {
      if (window.innerWidth <= 1024) closePromoDrawer();
    }, 150);
  });

function updateProductCardImage(selectedSwatch) {
  const productCard = selectedSwatch.closest('.card-wrapper');
  if (!productCard) return;

  // --- Image update (no opacity fade — causes flicker) ---
  const variantImage = selectedSwatch.getAttribute('data-variant-image');
  const productImage = productCard.querySelector('.card__inner img, .product-card__image img');

  if (variantImage && productImage) {
    productImage.src = variantImage;
    productImage.srcset = '';
  }

  // --- Price update ---
  const swatchLabel =
    productCard.querySelector(`label[for="${selectedSwatch.id}"]`) ||
    selectedSwatch.nextElementSibling;

  if (!swatchLabel) return;

  const newPrice        = swatchLabel.getAttribute('data-price');
  const newComparePrice = swatchLabel.getAttribute('data-compare-price');

  if (!newPrice) return;

  const priceWrapper =
    productCard.querySelector('.price__container') ||
    productCard.querySelector('.price') ||
    productCard.querySelector('.card-title_info');

  if (!priceWrapper) return;

  const regularPriceEl =
    priceWrapper.querySelector('.price-item--regular') ||
    priceWrapper.querySelector('.mini-price .price-item--regular') ||
    priceWrapper.querySelector('.price__regular .price-item');

  const salePriceEl =
    priceWrapper.querySelector('.price-item--sale') ||
    priceWrapper.querySelector('.mini-price .price-item--sale') ||
    priceWrapper.querySelector('.price__sale .price-item--sale');

  const comparePriceEl =
    priceWrapper.querySelector('.price-item--compare') ||
    priceWrapper.querySelector('.mini-price .price-item--compare') ||
    priceWrapper.querySelector('.price__sale .price-item--compare');

  const hasSale =
    newComparePrice &&
    newComparePrice !== newPrice &&
    newComparePrice !== '$0.00';

  if (hasSale) {
    if (comparePriceEl) comparePriceEl.textContent = newComparePrice;
    if (salePriceEl)    salePriceEl.textContent    = newPrice;
    if (regularPriceEl) regularPriceEl.textContent = newPrice;
    priceWrapper.classList.add('price--on-sale');
  } else {
    if (regularPriceEl) regularPriceEl.textContent = newPrice;
    if (salePriceEl)    salePriceEl.textContent    = newPrice;
    if (comparePriceEl) comparePriceEl.textContent = '';
    priceWrapper.classList.remove('price--on-sale');
  }
}

  // Initialize swatch image-swap + price-update listeners for promo drawer
function initializeSwatchesForPromoDrawer() {
  const promoDrawer = document.getElementById('promo-drawer');
  if (!promoDrawer) return;

  const colorSwatches = promoDrawer.querySelectorAll('.color-swatch-input');
  if (!colorSwatches.length) return;

  colorSwatches.forEach((swatch) => {
    const newSwatch = swatch.cloneNode(true);
    swatch.parentNode.replaceChild(newSwatch, swatch);

    // Update on radio change (click)
    newSwatch.addEventListener('change', (e) => {
      updateProductCardImage(e.target);
    });

    // Get the label (visually the swatch circle) — pointer-events: none is on it via CSS
    // so we use JS to attach the listener instead
    const label = newSwatch.nextElementSibling;
    if (!label || !label.classList.contains('color-swatch')) return;

    label.addEventListener('mouseenter', function () {
      const input = label.previousElementSibling;
      if (input) updateProductCardImage(input);
    });

    label.addEventListener('mouseleave', function () {
      const productCard = label.closest('.card-wrapper');
      if (!productCard) return;
      const checkedSwatch = productCard.querySelector('.color-swatch-input:checked');
      if (checkedSwatch) updateProductCardImage(checkedSwatch);
    });

    // Prevent label from blocking Swiper drag
    label.addEventListener('mousedown', function (e) {
      e.preventDefault();
    });
  });
}

  // ─── Discount → promo-tag mapping ───────────────────────────────────────
  const discountToPromoTag = {
    'honest tees bogo 50%'       : '2+ for 50% off',
    'buy 2 fleece get 25% off'   : '2+ for 25% off',
    'buy 2 socks get 3rd free'   : 'Buy 2, Get 1 Free',
    '3 hats or tees for 20% off' : '3+ for 20% off',
    'truth fits bogo 50% off'    : '2+ tanks for 50% off'
  };

  async function hideActivatedPromoTags(cartData) {
    if (!document.querySelector('.rebuy-cart .promo-tag-container')) return;

    try {
      const cart = cartData || await fetch('/cart.js').then(r => r.json());

      const activeDiscounts = new Set();

      if (cart.cart_level_discount_applications) {
        cart.cart_level_discount_applications.forEach(d => {
          activeDiscounts.add(d.title.toLowerCase().trim());
        });
      }

      if (cart.items) {
        cart.items.forEach(item => {
          if (item.discounts) {
            item.discounts.forEach(d => {
              activeDiscounts.add(d.title.toLowerCase().trim());
            });
          }
          if (item.line_level_discount_applications) {
            item.line_level_discount_applications.forEach(d => {
              activeDiscounts.add(d.title.toLowerCase().trim());
            });
          }
        });
      }

      const promoTagsToHide = new Set();
      activeDiscounts.forEach(discountTitle => {
        if (discountToPromoTag[discountTitle]) {
          promoTagsToHide.add(discountToPromoTag[discountTitle]);
          return;
        }
        Object.entries(discountToPromoTag).forEach(([key, promoTag]) => {
          if (discountTitle.includes(key) || key.includes(discountTitle)) {
            promoTagsToHide.add(promoTag);
          }
        });
      });

      document.querySelectorAll('.rebuy-cart .promo-tag-container').forEach(container => {
        const promoType = container.getAttribute('data-promo-type');
        if (promoTagsToHide.has(promoType)) {
          container.style.display = 'none';
          container.setAttribute('data-discount-active', 'true');
        } else {
          if (container.getAttribute('data-discount-active') === 'true') {
            container.style.display = '';
            container.removeAttribute('data-discount-active');
          }
        }
      });

    } catch (error) {
      console.error('Error checking active discounts:', error);
    }
  }

})();